import OriginalSteps from './Steps.svelte';
import OriginalStep from './Step.svelte';
import Title from './Title.svelte';
import Description from './Description.svelte';
import Summary from './Summary.svelte';
const Steps = OriginalSteps;
Steps.Summary = Summary;
Steps.Step = OriginalStep;
Steps.Step.Title = Title;
Steps.Step.Description = Description;
export default Steps;
